import './utils/fakeGoogle'; // DEVELOPMENT ONLY
import './utils/fakeChrome'; // DEVELOPMENT ONLY

import React from 'react';
import { render } from 'react-dom';
import { applyMiddleware, createStore } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import logger from 'redux-logger';
import initSubscriber from 'redux-subscriber';
import rootReducer from './reducers';
import saveToStorage from './utils/saveToStorage';

import App from './App';

const myStore = createStore(
	rootReducer,
	window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
	applyMiddleware(thunk),
	applyMiddleware(logger),
);

const subscribe = initSubscriber(myStore);

subscribe('lastVerification', saveToStorage.lastVerification);
subscribe('allPets', saveToStorage.allPets);
subscribe('activePet.shuffle', saveToStorage.activePet);
subscribe('activePet.active.petType', saveToStorage.activePet);
subscribe('collectedGoodies', saveToStorage.collectedGoodies);
subscribe('activeGoodies', saveToStorage.activeGoodies);

render(
	<Provider store={myStore}>
		<App />
	</Provider>,
	document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js